import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MarqueeSection from "./components/MarqueeSection";
import IlProblema from "./components/IlProblema";
import MetodoSintesi from "./components/MetodoSintesi";
import DualApproach from "./components/DualApproach";
import SportSection from "./components/SportSection";
import Method from "./components/Method";
import Filosofia from "./components/Filosofia";
import Testimonials from "./components/Testimonials";
import QualificationForm from "./components/QualificationForm";
import DiventaCoach from "./components/DiventaCoach";
import Footer from "./components/Footer";
import PrivacyPage from "./components/PrivacyPage";
import CookieConsent from "./components/CookieConsent";

function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
      touchMultiplier: 1.5,
    });
    window.__lenis = lenis;
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <MarqueeSection />
        <IlProblema />
        <MetodoSintesi />
        <DualApproach />
        <SportSection />
        <Method />
        <Filosofia />
        <Testimonials />
        <QualificationForm />
        <DiventaCoach />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </BrowserRouter>
      <CookieConsent />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "hsl(0 0% 6%)",
            border: "1px solid hsl(0 0% 15%)",
            color: "hsl(60 5% 96%)",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
